import script from "./ShiftView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftView.vue?vue&type=script&setup=true&lang=ts"

import "./ShiftView.vue?vue&type=style&index=0&id=78cb9e26&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cb9e26"]])

export default __exports__